<div class="space"></div>

<section id="acceleracion">
    <article class="banner">
        <img class="bg" src="../../../../assets/img/acceleracion-digital/bg.webp" alt="digital">
        <div class="wrapper">
            <div class="info">
                <h1>{{ 'cloud.title107' | translate }}</h1>
                <h2>‍<b>{{ 'cloud.title108' | translate }}</b><br>{{ 'cloud.title109' | translate }}</h2>
                <img src="../../../../assets/img/acceleracion-digital/logo.webp" alt="logo">
                <div class="ibutton">
                    <div class="sim-button button14" (click)='scroll(ibox)'>
                        <span>{{ 'cloud.title110' | translate }}</span>
                        <img class="arrow22" src="../../../../assets/img/arrow.svg" alt="">
                    </div>
                </div>
                
            </div>
            <div class="img">
                <div class="circle">
                    <img src="../../../../assets/img/acceleracion-digital/banner-meeting.webp" alt="banner">
                </div>
            </div>
        </div>
    </article>

    <article class="apps">
        <div class="wrapper">
            <p class="select">{{ 'cloud.title111' | translate }}</p>
            <div class="apps-wrap">
                <div class="productividad">
                    <h2>{{ 'cloud.title112' | translate }}</h2>
                    <div class="app">
                        <div class="img">
                            <img src="../../../../assets/img/acceleracion-digital/digi.svg" alt="digiflow">
                        </div>
                        <div class="info">
                            <h3>Digiflow</h3>
                            <p>{{ 'cloud.title113' | translate }}</p>
                        </div>
                    </div>
                    <div class="app">
                        <div class="img">
                            <img src="../../../../assets/img/acceleracion-digital/minutas.svg" alt="minuta">
                        </div>
                        <div class="info">
                            <h3>{{ 'cloud.title114' | translate }}</h3>
                            <p>{{ 'cloud.title115' | translate }}</p>
                        </div>
                    </div>
                    <div class="app">
                        <div class="img">
                            <img src="../../../../assets/img/acceleracion-digital/documentos.svg" alt="documentos">
                        </div>
                        <div class="info">
                            <h3>{{ 'cloud.title116' | translate }}</h3>
                            <p>{{ 'cloud.title117' | translate }}</p>
                        </div>
                    </div>
                    <div class="app">
                        <div class="img">
                            <img src="../../../../assets/img/acceleracion-digital/juntas.svg" alt="juntas">
                        </div>
                        <div class="info">
                            <h3>{{ 'cloud.title118' | translate }}</h3>
                            <p>{{ 'cloud.title119' | translate }}</p>
                        </div>
                    </div>
                    <div class="app">
                        <div class="img">
                            <img src="../../../../assets/img/acceleracion-digital/mesa.svg" alt="mesa de ayuda">
                        </div>
                        <div class="info">
                            <h3>{{ 'cloud.title120' | translate }}</h3>
                            <p>{{ 'cloud.title121' | translate }}</p>
                        </div>
                    </div>
                    <div class="app">
                        <div class="img">
                            <img src="../../../../assets/img/acceleracion-digital/cotiza.svg" alt="cotizador">
                        </div>
                        <div class="info">
                            <h3>{{ 'cloud.title122' | translate }}</h3>
                            <p>{{ 'cloud.title123' | translate }}</p>
                        </div>
                    </div>
                </div>
                <div class="rh">
                    <h2>{{ 'cloud.title124' | translate }}</h2>
                    <div class="app">
                        <div class="img">
                            <img src="../../../../assets/img/acceleracion-digital/notificacion.svg" alt="notificacion">
                        </div>
                        <div class="info">
                            <h3>{{ 'cloud.title125' | translate }}</h3>
                            <p>{{ 'cloud.title126' | translate }}</p>
                        </div>
                    </div>
                    <div class="app">
                        <div class="img">
                            <img src="../../../../assets/img/acceleracion-digital/directorio.svg" alt="directorio">
                        </div>
                        <div class="info">
                            <h3>{{ 'cloud.title127' | translate }}</h3>
                            <p>{{ 'cloud.title128' | translate }}</p>
                        </div>
                    </div>
                    <div class="app">
                        <div class="img">
                            <img src="../../../../assets/img/acceleracion-digital/vacaciones.svg" alt="vacaciones">
                        </div>
                        <div class="info">
                            <h3>{{ 'cloud.title129' | translate }}</h3>
                            <p>{{ 'cloud.title130' | translate }}</p>
                        </div>
                    </div>
                    <div class="app">
                        <div class="img">
                            <img src="../../../../assets/img/acceleracion-digital/onboard.svg" alt="onboarding">
                        </div>
                        <div class="info">
                            <h3>{{ 'cloud.title131' | translate }}</h3>
                            <p>{{ 'cloud.title132' | translate }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </article>

    <article class="servicios">
        <h2><span>{{ 'cloud.title133' | translate }}</span></h2>
        <div class="wrapper">
            <div class="develop">
                <h3>{{ 'cloud.title134' | translate }}</h3>
                <div class="card-wrapper">
                    <div class="card">
                        <div class="img">
                            <img src="../../../../assets/img/acceleracion-digital/develop.svg" alt="develop">
                        </div>
                        <div class="info">
                            <h3>{{ 'cloud.title135' | translate }}</h3>                            
                            <ul>
                                <li>{{ 'cloud.title136' | translate }}</li>
                                <li>{{ 'cloud.title137' | translate }}</li>
                            </ul>
                        </div>
                    </div>
        
                    <div class="card">
                        <div class="img">
                            <img class="antena" src="../../../../assets/img/acceleracion-digital/intranet.svg" alt="intranet">
                        </div>
                        <div class="info">
                            <h3>{{ 'cloud.title138' | translate }}</h3>                            
                            <ul>
                                <li>{{ 'cloud.title139' | translate }}</li>
                                <li>
                                    {{ 'cloud.title140' | translate }}
                                    <ul>
                                        <li>{{ 'cloud.title141' | translate }}</li>
                                        <li>{{ 'cloud.title142' | translate }}</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        
                    </div>
        
                    <div class="card">
                        <div class="img">
                            <img src="../../../../assets/img/acceleracion-digital/conection.svg" alt="integracion">
                        </div>
                        <div class="info">
                            <h3>{{ 'cloud.title143' | translate }}</h3>                            
                            <ul>
                                <li>Google Workspace</li>
                                <li>Microsoft 365</li>
                                <li>Google Cloud Platform</li>
                                <li>Azure</li>
                                <li>Copper</li>
                                <li>SAP</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div class="consultoria">
                <h3>{{ 'cloud.title144' | translate }}</h3>
                <div class="card-wrapper">
                    <div class="card bar">
                        <div class="img">
                            <img src="../../../../assets/img/acceleracion-digital/auto.svg" alt="automatización">
                        </div>
                        <div class="info">
                            <h3>{{ 'cloud.title145' | translate }}</h3>
                            <ul>
                                <li>{{ 'cloud.title146' | translate }}</li>
                                <li>{{ 'cloud.title147' | translate }}</li>
                                <li>{{ 'cloud.title148' | translate }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </article>

    <article class="credenciales">
        <img class="bg" src="../../../../../assets/img/microsoft365/clouds.png" alt="clouds">
        <div class="wrapper">
            <h2>{{ 'cloud.title149' | translate }}</h2>
            <div class="badges-wrapper">
                <img src="../../../../assets/img/google-badge.webp" alt="google-badge">
                <img src="../../../../assets/img/microsoft.webp" alt="microsoft-badge">
            </div>
            <br><br>
            <h3>{{ 'cloud.title150' | translate }}</h3>
            <div class="clients-wrapper">
                <img src="../../../../assets/img/acceleracion-digital/locatel.webp" alt="locatel">
                <img src="../../../../assets/img/acceleracion-digital/krispy.png" alt="krispy kreme">
                <img src="../../../../assets/img/acceleracion-digital/banesco.gif" alt="banesco">
                <img src="../../../../assets/img/acceleracion-digital/flor-de-cana.webp" alt="flor de caña">
            </div>
        </div>
    </article>

<!-- <app-interes [intereses]="interesesCards"></app-interes> -->

    <article class="intereses">
        <div class="wrapper">
            <h3>{{ 'cloud.title151' | translate }}</h3>
            <div class="card-wrapper">
                <div class="card" routerLink="/workspace">
                    <img class="img-iconb" src="../../../../../assets/img/Google_Workspace_Logo.svg" alt="Cloud">
                    <img class="arrow" src="../../../../assets/img/blue-arrow.svg" alt="arrow">
                </div>
                <div class="card" routerLink="/rackspace">
                    <div class="box22">
                        <div class="barra22">
                            <img class="img-iconb" src="../../../../../assets/img/rackspace/Rackspace_Technology_Logo_RGB_BLK.webp" alt="Maps">
                        </div>
                        <div class="barra22">
                            <p>Email</p>
                        </div>
                    </div>
                    <img class="arrow" src="../../../../assets/img/blue-arrow.svg" alt="arrow">
                </div>
                
            </div>
        </div>
    </article>

    <div #ibox>
       <app-form id="form-g"></app-form> 
    </div>
    
</section>